/**
 * Public default when a post has no `coverImageUrl` from the API (same asset as OG metadata).
 */
export const BLOG_DEFAULT_COVER_SRC = "/og-default.png";
